import { motion } from "framer-motion";
import React from "react";
import "./AnimatedLogo.css";

function AnimatedLogo(props) {
  return (
    <>
      <motion.svg
        width="90%"
        viewBox="0 0 380 70"
        className="animated-logo mt-2 mb-5"
      >
        <motion.polygon
          className="hybride"
          points="6,6 41,13 41,42 6,49"
          initial={{
            opacity: 0,
            x: 462,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.7,
            ease: "easeInOut",
          }}
        />
        <motion.polygon
          className="perform"
          points="6,6 41,13 41,42 6,49"
          initial={{
            opacity: 0,
            x: 462,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.6,
            delay: 0.2,
            ease: "easeInOut",
          }}
        />
        <motion.polygon
          className="textural"
          points="6,6 41,13 41,42 6,49"
          initial={{
            opacity: 0,
            x: 462,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.6,
            delay: 0.35,
            ease: "easeInOut",
          }}
        />
        <motion.polygon
          className="aluminium"
          points="6,6 41,13 41,42 6,49"
          initial={{
            opacity: 0,
            x: 462,
          }}
          animate={{
            opacity: 1,
            x: 0,
          }}
          transition={{
            duration: 0.6,
            delay: 0.5,
            ease: "easeInOut",
          }}
        />
        <motion.polygon
          className="full"
          points="6,6 41,13 41,42 6,49"
          initial={{
            opacity: 0,
          }}
          animate={{
            opacity: [0, 0, 1],
          }}
          transition={{
            duration: 0.7,
            delay: 0.5,
            ease: "linear",
          }}
        />
        <motion.path
          className="logo-text"
          viewBox="0 0 300 70"
          d="m 107.58977,37.569967 c -5.97885,-0.747423 -10.373125,-3.426546 -12.411521,-7.567123 -1.348211,-2.738605 -1.628982,-4.634221 -1.628982,-10.997861 0,-6.452985 0.269885,-8.206228 1.700556,-11.0471607 2.719894,-5.400987 8.410137,-7.82459401 18.354267,-7.81751601 5.70793,0.0041 9.66659,0.690365 12.80301,2.21962201 3.30774,1.612792 5.42053,4.101464 6.69175,7.8822777 0.67224,1.999345 0.69716,2.298799 0.707,8.495162 0.008,4.566752 -0.0955,6.848102 -0.35572,7.894649 -1.31154,5.275375 -4.95579,8.894726 -10.33868,10.268044 -3.65561,0.932647 -10.91402,1.245915 -15.52168,0.669906 z m 14.12483,-6.917471 c 4.3701,-1.498314 6.06359,-4.751326 6.06359,-11.647513 0,-5.19875 -0.83667,-7.971337 -2.98959,-9.9069917 -2.12235,-1.908182 -4.95346,-2.526087 -11.57891,-2.527168 -6.06764,-0.0011 -8.88659,0.752258 -11.03998,2.949987 -0.62603,0.6389037 -1.40796,1.8299467 -1.73762,2.6467557 -0.551307,1.365949 -0.599402,1.914571 -0.599402,6.837417 0,4.911148 0.049,5.473622 0.594822,6.824187 1.7946,4.440754 4.93902,5.658917 14.25406,5.522099 4.64145,-0.06818 5.41914,-0.145441 7.03303,-0.698773 z m -49.851465,1.733247 -5.213348,-5.218496 -3.481569,-0.0027 c -3.097788,-0.0024 -3.629069,-0.07217 -4.819645,-0.633619 -0.735943,-0.347054 -1.601567,-0.917907 -1.923606,-1.268558 -0.721241,-0.785335 -1.675393,-2.842343 -1.683328,-3.629007 l -0.0061,-0.582919 8.898205,-0.09379 c 8.612275,-0.09078 8.949804,-0.114135 10.503899,-0.726854 2.002431,-0.789483 3.965119,-2.655791 4.383939,-4.168666 C 79.505532,12.506865 77.898965,9.1795353 74.549977,7.8356333 73.125116,7.2638553 72.672478,7.2371043 62.96471,7.1509423 L 52.862418,7.0612523 V 19.196798 c 0,13.173876 -0.07642,14.011653 -1.441283,15.801087 -0.832565,1.091623 -3.088837,2.338697 -4.231174,2.338697 H 46.439666 V 19.138791 0.94095629 h 12.821988 c 14.674969,0 15.59236,0.09074 19.275889,1.90665501 3.990835,1.967407 6.091944,4.817748 6.731454,9.1317927 0.859958,5.801177 -1.744987,10.729641 -7.020926,13.28334 -1.25181,0.605911 -2.446786,1.101657 -2.655505,1.101657 -0.20872,0 2.147322,2.528964 5.235651,5.619919 l 5.615137,5.61992 H 81.759907 77.07646 Z m 116.278815,4.975264 c -1.85831,-0.468618 -3.34369,-1.673717 -4.3182,-3.50338 -0.46818,-0.879004 -0.5035,-1.920814 -0.57385,-16.926662 l -0.075,-15.99000871 13.45573,0.0058 c 12.47754,0.0055 13.53354,0.04158 14.52618,0.49692901 1.94145,0.890601 3.61281,3.129139 3.61281,4.838837 v 0.813507 H 202.19176 189.61384 V 19.138754 31.181438 h 12.61274 12.6127 l -0.13914,1.234481 c -0.18034,1.599953 -1.31241,3.204731 -2.9948,4.2453 l -1.30826,0.809177 -10.72613,0.04652 c -5.89939,0.02559 -11.08743,-0.04459 -11.52899,-0.155942 z m 64.1128,-4.956263 -5.19435,-5.199499 -3.81317,-0.0859 c -3.75108,-0.08451 -3.83196,-0.0991 -4.96499,-0.896225 -1.49629,-1.052702 -2.64029,-2.702962 -2.8242,-4.074027 l -0.14654,-1.092678 8.93046,-0.100155 c 8.57947,-0.09622 8.99181,-0.124463 10.4912,-0.71863 3.00318,-1.190096 4.53336,-3.215485 4.57052,-6.04972 0.0413,-3.153053 -1.53167,-5.4494967 -4.42223,-6.4560617 -1.31033,-0.456286 -2.35408,-0.501934 -11.47697,-0.501934 H 233.36891 L 233.2351,20.209252 c -0.14775,14.332863 -0.0647,13.664101 -1.91739,15.441216 -0.99828,0.957592 -2.53658,1.686158 -3.56013,1.686158 h -0.67763 V 19.138791 0.94095629 h 12.85682 c 10.56063,0 13.2252,0.07424 14.91955,0.41568701 5.5566,1.11978 9.69045,4.678409 10.74419,9.2491447 0.44443,1.927753 0.34212,5.62182 -0.20414,7.371796 -1.13273,3.628626 -3.96761,6.471393 -7.87519,7.897098 -0.84634,0.30879 -1.53879,0.61465 -1.53879,0.679691 0,0.06504 2.49885,2.572604 5.55302,5.572362 l 5.55301,5.454105 -4.81964,0.0117 -4.81964,0.0117 -5.19439,-5.199497 z m 55.64499,-8.915116 V 9.3750183 l -6.35794,6.3538137 -6.35795,6.353811 -6.28686,-6.291534 -6.28688,-6.2915377 -0.13381,11.7322377 -0.1338,11.732235 -0.80993,1.309465 c -0.94282,1.524369 -2.77096,2.770358 -4.38162,2.986396 l -1.09742,0.147194 V 18.906412 0.40572629 h 3.14657 3.14657 l 6.41865,6.42280801 6.41861,6.4228047 6.42681,-6.4228047 6.42683,-6.42280801 h 3.14247 3.14247 V 19.004983 37.60424 h -3.21138 -3.21138 z M 0.677495,19.138791 V 0.94095629 h 12.85681 c 14.172975,0 15.408603,0.10775001 18.704854,1.63110601 5.25967,2.430747 7.413319,6.081412 7.20353,12.2107317 -0.09721,2.83998 -0.13883,3.013323 -1.273225,5.302624 -1.382143,2.789283 -3.018659,4.552686 -5.288411,5.698456 -2.51197,1.268039 -3.970641,1.426022 -12.310704,1.333334 l -7.537704,-0.08377 -1.15231,-0.81032 c -1.47797,-1.039313 -2.5796,-2.635938 -2.79734,-4.054229 l -0.17162,-1.117938 8.9293,-0.094 c 8.627079,-0.09082 8.983649,-0.11531 10.534993,-0.723549 2.205941,-0.864884 3.959653,-2.672785 4.408794,-4.545029 0.849307,-3.540317 -0.90289,-6.7710097 -4.317468,-7.9605087 -1.295367,-0.451253 -2.370433,-0.497947 -11.464969,-0.497947 H 6.966455 L 6.832645,20.209255 c -0.14776,14.332863 -0.0647,13.664101 -1.91738,15.441216 -0.9983,0.957592 -2.53658,1.686158 -3.56014,1.686158 H 0.677495 Z M 147.71125,36.689416 c -1.21913,-0.53085 -2.74166,-1.964365 -3.40706,-3.207874 -0.58188,-1.087401 -0.58694,-1.21732 -0.6614,-16.952 l -0.075,-15.85620071 h 16.47858 16.4786 l -0.17137,1.00355701 c -0.27188,1.592249 -1.46079,3.307804 -2.91612,4.207864 l -1.30959,0.809921 -10.92674,0.07552 -10.92673,0.07552 v 3.7380007 3.738001 h 8.33087 8.33088 l -0.13914,1.23448 c -0.24202,2.147173 -2.17668,4.285346 -4.44844,4.91638 -0.53248,0.147906 -3.46699,0.269593 -6.52115,0.270412 l -5.55302,0.0015 v 8.162264 8.162264 l -0.86975,-0.01046 c -0.47836,-0.0058 -1.24039,-0.171853 -1.69339,-0.369106 z m 44.57873,-17.405864 v -3.088529 h 10.46678 10.46678 l -0.17893,1.003557 c -0.28226,1.583121 -1.48893,3.308024 -2.94367,4.207864 l -1.30935,0.809921 -8.25079,0.07786 -8.25082,0.07786 z"
          style={{
            x: 57,
            y: 8,
          }}
          initial={{
            opacity: 0,
            x: 75,
          }}
          animate={{
            opacity: 1,
            x: 57,
          }}
          transition={{
            duration: 0.4,
            delay: 0.8,
            ease: "easeInOut",
          }}
        ></motion.path>
        <motion.text
          className="title-muted-text"
          y="65"
          initial={{
            opacity: 0,
            x: 0,
          }}
          animate={{
            opacity: 1,
            x: 56,
          }}
          transition={{
            duration: 0.1,
            delay: 0.7,
            ease: "easeInOut",
            x: {
              type: "spring",
              damping: 7,
              stiffness: 80,
              restDelta: 0.001,
            },
          }}
        >
          Fabricant français de menuiseries innovantes
        </motion.text>
      </motion.svg>
    </>
  );
}

export default AnimatedLogo;
